export default __webpack_public_path__ + "static/media/18.a3ea02c7.jpg";